<template>
  <div class="catalogue s-new-theme">
    <div class="catalogue-task">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 3 ? 'ing' : ''"
      >
        {{ index + 1 }}. {{ item.nameEn }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        Done
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="catalogue-header">
      <p>Exhibition Application/参展申请</p>
      <span></span>
      <p>Show Catalogue/会刊信息</p>
    </div>

    <div class="catalogue-content">
      <!-- <div class="f">
        <p>Company Profile in Chinese/公司中文介绍 </p>
        <span>{{introduction.length}}/100</span>
      </div>
      <Input v-model="introduction" maxlength="100" :rows="6" type="textarea" style="width: 600px;" /> -->
      <p class="tip">
        The information will be collected in the show catalogue if your
        application is approved/若您申请展位成功，此部分信息将作为会刊信息
      </p>
      <div class="f">
        <p>Company Profile in English/公司英文介绍</p>
        <span>{{ introductionEn.length }}/350</span>
      </div>
      <Input
        v-model="introductionEn"
        maxlength="350"
        :rows="6"
        type="textarea"
        style="width: 600px"
      />
    </div>

    <div class="catalogue-btn" v-if="showNow">
      <Button
        type="primary"
        size="large"
        @click="goBack"
        style="margin-right: 20px"
        class="s-btn-red"
        >Previous/上一步</Button
      >
      <template v-if="speenInfo && speenInfo.speed < 4">
        <Button type="primary" size="large" @click="submit" class="s-btn-red"
          >Save and Proceed
          <br />
          提交并下一步</Button
        >
      </template>
      <template v-else>
        <Button
          type="primary"
          size="large"
          @click="submit"
          style="margin-right: 20px"
          class="s-btn-red"
          >Update/更新</Button
        >
        <Button type="primary" size="large" @click="goNext" class="s-btn-red"
          >Proceed/下一步</Button
        >
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "catalogue", // 参展申请
  data() {
    return {
      list: [],
      speenInfo: null,
      introduction: "",
      introductionEn: "",
      orderInfo: null,
      showNow: false,
    };
  },
  components: {},
  computed: {
    exhibitionId() {
      return this.$route.query.id;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId() {
      return this.$route.query.groupId;
    },
  },
  methods: {
    ...mapActions({
      getOrderDetail: "getOrderDetail",
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      updateIntroduction: "updateIntroduction",
    }),
    async init() {
      // 流程
      let list = await this.getApplyFlow();
      this.list = list;

      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      this.showNow = false;
      if (info) {
        this.showNow = true;
      }
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.list && this.list.length > 0) {
          this.list.map((c) => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push(
            "/join/basicEn?applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.applyCompanyOrderId
          );
        } else {
          this.$router.push(
            "/join/basicEn?applyCompanyId=" + this.applyCompanyId
          );
        }
      }

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.replace("/join/finishEn");
      }
      this.orderInfo = orderInfo;
      this.introduction = orderInfo.introduction || "";
      this.introductionEn = orderInfo.introductionEn || "";
      console.log("订单信息：", this.orderInfo);
    },
    async submit() {
      if (!this.introductionEn) {
        this.$Message.warning("Please enter company profile/请输入公司介绍");
        return;
      }
      let req = {
        Id: this.applyCompanyOrderId,
        Introduction: this.introduction,
        IntroductionEn: this.introductionEn,
      };
      let info = await this.updateIntroduction(req);
      if (info && info.successed) {
        if (this.speenInfo && this.speenInfo.speed < 4) {
          this.$Message.success("Submitted！/提交成功！");
          if (this.groupId) {
            this.$router.push(
              "/join/applicationEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId
            );
          } else {
            this.$router.push(
              "/join/applicationEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          }
        } else {
          this.$Message.success("Update Success！/更新成功！");
          this.init();
        }
      }
    },
    goBack() {
      if (this.groupId) {
        this.$router.push(
          "/join/orderEn?id=" +
            this.exhibitionId +
            "&applyCompanyId=" +
            this.applyCompanyId +
            "&applyCompanyOrderId=" +
            this.applyCompanyOrderId +
            "&groupId=" +
            this.groupId
        );
      } else {
        this.$router.push(
          "/join/orderEn?id=" +
            this.exhibitionId +
            "&applyCompanyId=" +
            this.applyCompanyId +
            "&applyCompanyOrderId=" +
            this.applyCompanyOrderId
        );
      }
    },
    goNext() {
      if (this.groupId) {
        this.$router.push(
          "/join/applicationEn?id=" +
            this.exhibitionId +
            "&applyCompanyId=" +
            this.applyCompanyId +
            "&applyCompanyOrderId=" +
            this.applyCompanyOrderId +
            "&groupId=" +
            this.groupId
        );
      } else {
        this.$router.push(
          "/join/applicationEn?id=" +
            this.exhibitionId +
            "&applyCompanyId=" +
            this.applyCompanyId +
            "&applyCompanyOrderId=" +
            this.applyCompanyOrderId
        );
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang='scss'>
.catalogue {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;
    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;
        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }
    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }
    .ing {
      color: #00bdca;
      .box {
        div {
          background-color: #00bdca;
        }
      }
    }
    .finished {
      color: #00bdca;
      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-content {
    width: 600px;
    margin: 50px auto 0;
    .f {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .tip {
      margin: 5px 0;
    }
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;
    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}
</style>